
        var result = require("!!../../../node_modules/css-loader/index.js!./appointment-list.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/shared/appointment-list.component.css
// module id = 2465
// module chunks = 1